<template>
    <div class="form-container">
        <ValidationObserver v-slot="{ handleSubmit, errors }" v-if="sent == false">
            <div v-if="freeformData.formTitle" v-html="freeformData.formTitle"></div>
            <form @submit.prevent="onSubmit" id="freeform" method="POST" class="Recommendations">
                <input type="hidden" name="freeform_payload" :value="freeformData.freeform_payload" />
                <input type="hidden" name="formHash" :value="freeformData.hash" />
                <input type="hidden" name="freeform-action" value="submit" />
                <input type="hidden" :name="freeformData.csrf.name" :value="freeformData.csrf.token" />
                <input type="hidden" name="action" :value="freeformData.action" />
                <div class="container-xs donate-container">
                    <div class="donate-buttons-block">
                        <fieldset v-for="(row) in freeformFieldsLayout">
                            <ValidationProvider v-for="field in row" class="field field-wrapper" tag="div" :rules="{ required: true }" :id="field.handle" :name="field.label" v-slot="{ errors }" v-if="field.type != ('html')">
                                <div :id="field.handle" class="field">
                                    <label :for="field.handle" v-html="field.label + (field.required ? '*' : '')"></label>
                                    <input v-if="field.type == 'text'" :type="field.type" :name="field.handle" v-model="inputModel[field.handle]" :aria-required="field.required">
                                    <input v-else-if="field.type == 'phone'" type="tel" :name="field.handle" v-model="inputModel[field.handle]" pattern="[0-9]*" :aria-required="field.required">
                                    <input v-else-if="field.type == 'email'" type="email" :name="field.handle" v-model="inputModel[field.handle]" :aria-required="field.required">
                                    <select v-else-if="field.type === 'dropdown'" :name="field.handle" v-model="inputModel[field.handle]" :aria-required="field.required">
                                        <option value="" selected disabled>Please select</option>
                                        <option v-for="option in field.options" :key="option.value" :value="option.value">{{ option.label }}</option>
                                    </select>
                                    <textarea v-else-if="field.type == 'textarea'" type="text" :name="field.handle" v-model="inputModel[field.handle]" :aria-required="field.required"></textarea>
                                    <small class="error">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </fieldset>
                        <div class="donate-buttons-inner">
                            <!-- The submit button triggers onSubmit which now validates recaptcha before sending -->

                            <p v-if="loading">
                                Loading...
                            </p>

                            <button type="submit" class="btn btn-primary" aria-label="Send Enquiry" v-else>
                                Send Enquiry
                            </button>
                            <small v-for="(item, index) in submissionErrors" :key="index" class="error" v-html="item[0]"></small>
                        </div>
                        <div v-if="currentSite == 'GB'" class="note">
                            By submitting this form, you agree to the
                            <a href="/gb-ie/legal/terms-conditions">Terms &amp; Conditions</a> and
                            <a href="/gb-ie/legal/policies">Privacy Policy</a>.
                        </div>
                        <div v-else class="note">
                            By submitting this form, you agree to the
                            <a href="/legal/terms-conditions">Terms &amp; Conditions</a> and
                            <a href="/legal/privacy-policy">Privacy Policy</a>.
                        </div>
                    </div>
                </div>
            </form>
        </ValidationObserver>
        <div v-if="sent == true" class="text-left">
            <h2>Thank you for your submission</h2>
            <p>We will be in touch shortly.</p>
        </div>
    </div>
</template>

<script setup>

    import { onMounted, ref } from 'vue';
    import { useProductFinderStore } from '../stores/product-finder';

    const productFinderStore = useProductFinderStore();
    productFinderStore.loadStateFromLocalStorage();

    const inputModel = ref(window.freeformFieldsLayoutInputModel || {});
    const freeformData = ref(window.freeformData || {});
    const freeformFieldsLayout = ref(window.freeformFieldsLayout || {});
    const submissionErrors = ref({});
    const sent = ref(false);
    const loading = ref(false);
    const currentSite = ref(window.currentSite || {});

    onMounted(() => {
        productFinderStore.map = window.seatingSolutionFinderMap;
        productFinderStore.clear();
    });

    /**
     * Validate Google reCAPTCHA v3.
     * This function dynamically loads the reCAPTCHA script if not already loaded,
     * then executes it to get a token.
     */
    const validateGoogleRecaptcha = async () => {
        // Check if grecaptcha is already available
        if (typeof window.grecaptcha === 'undefined') {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=6Ld3jrAqAAAAAPeQUemBqiheyep5u13S3XnMLi0S`;
            document.head.appendChild(script);
            await new Promise(resolve => {
                script.onload = resolve;
            });
        }
        // Execute reCAPTCHA with your site key and action name
        return window.grecaptcha.execute('6Ld3jrAqAAAAAPeQUemBqiheyep5u13S3XnMLi0S', { action: 'submit' });
    };

    const onSubmit = async () => {
        try {
            const recaptchaResponse = await validateGoogleRecaptcha();
            if (recaptchaResponse) {
                submitForm(recaptchaResponse);
            } else {
                console.error("Recaptcha validation failed.");
            }
        } catch (error) {
            console.error("Error during reCAPTCHA validation:", error);
        }
    };

    const submitForm = (recaptchaResponse) => {
        const form = document.getElementById('freeform');
        const data = new FormData(form);

        loading.value = true;

        // Append the reCAPTCHA response to the form data
        data.append('g-recaptcha-response', recaptchaResponse);

        axios({
                url: form.getAttribute('action') || '/freeform/submit',
                method: form.getAttribute('method') || 'post',
                data: data,
                headers: {
                    'X-CSRF-Token': freeformData.value.csrf.token,
                    'Cache-Control': 'no-cache',
                    'X-Requested-With': 'XMLHttpRequest',
                    'HTTP_X_REQUESTED_WITH': 'XMLHttpRequest',
                    'X-Craft-Solspace-Freeform-Mode': 'Headless',
                },
                withCredentials: true,
            })
            .then(function(responseObject) {
                const response = responseObject.data;
                if (response.success && response.finished) {
                    if (freeformData.value.settings.behavior.returnUrl) {
                        window.location = freeformData.value.settings.behavior.returnUrl;
                    }
                } else if (response.errors || response.formErrors) {
                    loading.value = false;
                    console.log('Field Errors', response.errors);
                    console.log('Form Errors', response.formErrors);
                    submissionErrors.value = response.errors || response.formErrors;
                }
            })
            .catch(function(error) {
                console.error(error);
            });
    };

</script>
